import { useSnapshot } from 'valtio'
import { environment } from '../environment'

const defaultURLs = {
  serverUrl: '',
  podsBaseUrl: '',
  aiRoutingAssistantUrl: '',
  importWizardTemplateBaseUrl: '',
}

export const useEnvironmentURLs = () => {
  const { env } = useSnapshot(environment)

  return env.status === 'ready' ? env.urls : defaultURLs
}
